import { Button } from '@chakra-ui/button'
import { Input } from '@chakra-ui/input'
import { Select } from '@chakra-ui/select'
import { Td, Tr } from '@chakra-ui/table'
import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { baseURL } from '../../../../services/api'
import { InputUsage } from './InputUsage'

export function TrUsage({
  info,
  dadosContabilidade,
  dadosFat,
  index,
  getInputInitialValues,
  setVerifyLength,
  handleSequencia,
  handleCodProd,
}) {
  const [data, setData] = useState({
    iva: info[index]?.iva_cont_fat,
    icms_destino: info[index]?.icms_dest_fat,
    fundo_pobreza: info[index]?.fundo_pob_fat,
    icms_origem: info[index]?.icms_orig_ent,
    valor_icms: info[index]?.vlr_icms_fat,
    iva_ent: info[index]?.iva_cont_ent,
    status_st_fat: '',
    cest_fat: info[index]?.cest_fat,
    legislacao_fat: info[index]?.legislacao_fat,
    bc_icms_st_fat: info[index]?.bc_icms_st_fat,
    valor_fcp_fat: info[index]?.valor_fcp_fat,
    valor_icms_fcp_fat: info[index]?.bc_icms_st_fat,
    icms_destino_ent: info[index]?.icms_dest_ent,
    fundo_pobreza_ent: info[index]?.fundo_pob_ent,
    icms_origem_ent: info[index]?.bc_icms_st_ent,
    valor_icms_ent: info[index]?.vlr_icms_ent,
    status_st_ent: '',
    cest_ent: info[index]?.cest_ent,
    legislacao_ent: info[index]?.legislacao_ent,
    bc_icms_st_ent: info[index]?.bc_icms_st_ent,
    valor_fcp_ent: info[index]?.valor_fcp_ent,
    valor_icms_fcp_ent: '',
  })
  const [loading, setLoading] = useState(false)
  console.log(info)

  async function sendRowToBack() {
    const arrayDados = {
      cod_prod: info.codigo,
      sequencia: info.sequencia,
      numero_nota: info.numero_nota,
      iva_fat: data.iva.replace(',', '.'),
      icms_fat: data.icms_destino.replace(',', '.'),
      fundp_fat: data.fundo_pobreza.replace(',', '.'),
      icms_orig_fat: data.icms_origem.replace(',', '.'),
      vlr_icms_fat: data.valor_icms.replace(',', '.'),
      iva_ent: data.iva_ent.replace(',', '.'),
      icms_ent: data.icms_destino_ent.replace(',', '.'),
      fundp_ent: data.fundo_pobreza_ent.replace(',', '.'),
      icms_orig_ent: data.icms_origem_ent.replace(',', '.'),
      vlr_icms_ent: data.valor_icms_ent.replace(',', '.'),
      status_st_fat: data.status_st_fat,
      cest_fat: data.cest_fat.replace(',', '.'),
      legislacao_fat: data.legislacao_fat.replace(',', '.'),
      bc_icms_st_fat: data.bc_icms_st_fat.replace(',', '.'),
      valor_fcp_fat: data.valor_fcp_fat.replace(',', '.'),
      status_st_ent: data.status_st_ent,
      cest_ent: data.cest_ent.replace(',', '.'),
      legislacao_ent: data.legislacao_ent.replace(',', '.'),
      bc_icms_st_ent: data.bc_icms_st_ent.replace(',', '.'),
      valor_fcp_ent: data.valor_fcp_ent.replace(',', '.'),
      isFat: !dadosFat ? 0 : 1,
    }

    handleSequencia(info.sequencia)
    handleCodProd(info.codigo)

    try {
      setLoading(true)

      const response = await baseURL.post(
        '/pedido/inserir-informacoes-icms',
        arrayDados
      )

      console.log(response)
      setLoading(false)
      getInputInitialValues()
    } catch (error) {
      console.log('error', error)
      setLoading(false)
    }
  }

  const [change, setChange] = useState(true)
  const [disableInputs, setDisableInputs] = useState(false)

  useEffect(() => {
    if (
      data.status_st_fat === 'N' ||
      data.status_st_ent === 'N' ||
      change === false
    ) {
      setDisableInputs(true)
    }

    return () => {
      setDisableInputs(false)
    }
  }, [data.status_st_fat, data.status_st_ent, change])

  function changeBg() {
    if (data.status_st_fat === '' && data.status_st_ent === '') {
      alert('Selecione o status ST')
      return
    }

    setChange(!change)

    sendRowToBack()
    setVerifyLength((prev) => prev + 1)

    if (!change) {
      setVerifyLength((prev) => prev - 1)
    }

    return null
  }

  return (
    <Tr
      key={info.sequencia}
      _even={{
        bg: '#f3f3f3',
      }}
      bgColor="#fdfdfd"
      opacity={change ? 1 : 0.5}
      cursor={change ? 'pointer' : 'not-allowed'}
    >
      <Td textAlign="center">{info.codigo}</Td>
      <Td textAlign="center">{info.descricao}</Td>
      <Td textAlign="center">{info.ncm}</Td>
      <Td textAlign="center">{info.origem_produto}</Td>
      <Td textAlign="center">{info.quantidade}</Td>
      <Td textAlign="center">{info.valor_unitario}</Td>
      <Td textAlign="center">{info.valor_total}</Td>
      <Td textAlign="center">{info.rateio_frete}</Td>
      {/* <Td textAlign="center">{dadosContabilidade.nacional_importacao}</Td> */}
      <Td textAlign="center">
        {
          <Select
            width={{ base: '80px', md: '80px' }}
            name="tem_st"
            id="tem_st"
            opacity={1}
            disabled={change ? false : true}
            onChange={(e) => {
              !dadosFat
                ? setData({ ...data, status_st_fat: e.target.value })
                : setData({ ...data, status_st_ent: e.target.value })
            }}
          >
            <option value="">Selecione</option>
            <option value="S">Sim</option>
            <option value="N">Não</option>
          </Select>
        }
      </Td>
      <Td textAlign="center">
        <InputUsage
          disabled={disableInputs}
          defaultValue={
            !dadosFat ? info[index]?.cest_fat : info[index]?.cest_ent
          }
          onChange={(e) => {
            !dadosFat
              ? setData({ ...data, cest_fat: e.target.value })
              : setData({ ...data, cest_ent: e.target.value })
          }}
        />
      </Td>
      <Td textAlign="center">
        <InputUsage
          disabled={disableInputs}
          defaultValue={
            !dadosFat
              ? info[index]?.legislacao_fat
              : info[index]?.legislacao_ent
          }
          onChange={(e) => {
            !dadosFat
              ? setData({ ...data, legislacao_fat: e.target.value })
              : setData({ ...data, legislacao_ent: e.target.value })
          }}
        />
      </Td>
      <Td textAlign="center">
        <InputUsage
          disabled={disableInputs}
          defaultValue={
            !dadosFat
              ? info[index]?.bc_icms_st_fat
              : info[index]?.bc_icms_st_ent
          }
          onChange={(e) => {
            !dadosFat
              ? setData({ ...data, bc_icms_st_fat: e.target.value })
              : setData({ ...data, bc_icms_st_ent: e.target.value })
          }}
        />
      </Td>
      <Td textAlign="center">
        <InputUsage
          disabled={disableInputs}
          defaultValue={
            !dadosFat ? info[index]?.iva_cont_fat : info[index]?.iva_cont_ent
          }
          onChange={(e) => {
            !dadosFat
              ? setData({ ...data, iva: e.target.value })
              : setData({ ...data, iva_ent: e.target.value })
          }}
        />
      </Td>
      <Td textAlign="center">
        <InputUsage
          disabled={disableInputs}
          defaultValue={
            !dadosFat ? info[index]?.icms_dest_fat : info[index]?.icms_dest_ent
          }
          onChange={(e) => {
            !dadosFat
              ? setData({ ...data, icms_destino: e.target.value })
              : setData({ ...data, icms_destino_ent: e.target.value })
          }}
        />
      </Td>
      <Td textAlign="center">
        <InputUsage
          disabled={disableInputs}
          defaultValue={
            !dadosFat ? info[index]?.fundo_pob_fat : info[index]?.fundo_pob_ent
          }
          onChange={(e) => {
            !dadosFat
              ? setData({ ...data, fundo_pobreza: e.target.value })
              : setData({ ...data, fundo_pobreza_ent: e.target.value })
          }}
        />
      </Td>
      <Td textAlign="center">
        <InputUsage
          disabled={disableInputs}
          defaultValue={
            !dadosFat ? info[index]?.valor_fcp_fat : info[index]?.valor_fcp_ent
          }
          onChange={(e) => {
            !dadosFat
              ? setData({ ...data, valor_fcp_fat: e.target.value })
              : setData({ ...data, valor_fcp_ent: e.target.value })
          }}
        />
      </Td>
      <Td textAlign="center">
        <InputUsage
          disabled={disableInputs}
          defaultValue={
            !dadosFat ? info[index]?.icms_orig_fat : info[index]?.icms_orig_ent
          }
          onChange={(e) => {
            !dadosFat
              ? setData({ ...data, icms_origem: e.target.value })
              : setData({ ...data, icms_origem_ent: e.target.value })
          }}
        />
      </Td>
      <Td textAlign="center">
        <InputUsage
          disabled={disableInputs}
          defaultValue={
            !dadosFat ? info[index]?.vlr_icms_fat : info[index]?.vlr_icms_ent
          }
          onChange={(e) => {
            !dadosFat
              ? setData({ ...data, valor_icms: e.target.value })
              : setData({ ...data, valor_icms_ent: e.target.value })
          }}
        />
      </Td>
      <Td textAlign="center">
        <Input
          type="text"
          minW={'50px'}
          disabled
          value={
            !dadosFat
              ? info[index]?.valor_icms_fcp_fat
              : info[index]?.valor_icms_fcp_ent
          }
        />
      </Td>
      <Td textAlign="center">
        <Button
          colorScheme="blue"
          size="sm"
          bg={change ? '#5292a2' : '#003947'}
          _hover={{ filter: 'brightness(0.9)' }}
          isLoading={loading}
          onClick={() => {
            changeBg()
          }}
        >
          {change ? 'Salvar' : 'Editar'}
        </Button>
      </Td>
    </Tr>
  )
}
